// P10: one-click "create invoice → save to Dropbox → send to payment".
//
// Pure, dependency-injected orchestrator (the api functions are passed in) so it is
// unit-testable and the React component only has to map the result to toasts. Runs
// the three steps in order, stopping at the first failure, and reports exactly which
// step failed plus the invoice that was already created — so the caller can tell the
// user the resulting state (e.g. "created but not pushed, still a draft").
//
// @returns {Promise<{ ok: boolean, step: 'done'|'create'|'dropbox'|'status', created: object|null, error: Error|null }>}
//   never rejects — failures are returned as a structured result.
export async function createSaveSendInvoice ({
  contractId,
  payload,
  createInvoice,
  saveInvoiceToDropbox,
  updateInvoiceStatus,
}) {
  let created = null;

  try {
    created = await createInvoice(contractId, payload);
  } catch (error) {
    return { ok: false, step: 'create', created: null, error };
  }

  try {
    await saveInvoiceToDropbox(created.id);
  } catch (error) {
    return { ok: false, step: 'dropbox', created, error };
  }

  try {
    await updateInvoiceStatus(created.id, 'in_payment');
  } catch (error) {
    return { ok: false, step: 'status', created, error };
  }

  return { ok: true, step: 'done', created, error: null };
}
